export const ngWords = [
  '殺',
  '死',
  '消',
  '愛液',
  '愛奴',
  '青姦',
  '明盲',
  '朝勃ち',
  '足コキ',
  '穴兄弟',
  'アナニー',
  'あなる',
  'アナル',
  'アヘがお',
  'アヘ顔',
  '阿片',
  'アホ',
  'あほ',
  '阿呆',
  '粗チン',
  'いけぬま',
  '池沼',
  'イラマチオ',
  '淫',
  '陰核',
  '陰茎',
  '陰唇',
  '陰嚢',
  '陰部',
  '陰毛',
  'ヴァギナ',
  'うんこ',
  'う〇こ',
  'う●こ',
  'う◎こ',
  'うんち',
  'ウンコ',
  'ウンチ',
  'う〇ち',
  'う●ち',
  'う◎ち',
  '穢多',
  'エネマグラ',
  'エフェドリン',
  '援助交際',
  '援交',
  'オーガズム',
  '黄金水',
  'おっぱい',
  'オナニー',
  'オナヌー',
  'オナネタ',
  'オナホ',
  'オナホール',
  'オナル',
  'おまんちょ',
  'おめこ',
  'オルガズム',
  'がいじ',
  '害児',
  '顔騎',
  '顔射',
  '覚せい剤',
  '覚醒剤',
  'かくせいざい',
  'カスども',
  '我慢汁',
  '姦淫',
  '監禁',
  '姦通',
  'きえて',
  'きえろ',
  '亀甲縛り',
  'きちがい',
  'キチガイ',
  'ｷﾁｶﾞｲ',
  '気違い',
  '基地外',
  '逆援',
  '近親相姦',
  'キンタマ',
  'クズども',
  '屎',
  'クリトリス',
  'くろんぼ',
  'くんに',
  'クンニリングス',
  'けちゃまん',
  'けつあな',
  '毛唐',
  '抗うつ剤',
  '強姦',
  '口交',
  '肛交',
  '後背位',
  '口内射精',
  '口内発射',
  '合法ハーブ',
  '肛門',
  'コカイン',
  '乞食',
  'ゴミカス',
  'ゴミクズ',
  'ゴミども',
  'ゴ有',
  'ころして',
  'ころします',
  'ころす',
  'コロス',
  '56す',
  'コロナウイルス',
  'コンドーム',
  'ザー汁',
  'ザーメン',
  'ザコ',
  'ざこ',
  'ザッコ',
  'サセ子',
  '三国人',
  '第三国人',
  '自慰',
  'Gスポット',
  '視姦',
  'シコシコ',
  'じさつ',
  '自殺',
  'しっこ',
  '支那',
  'しね',
  'シネ',
  '4ね',
  '4NE',
  'タヒね',
  'ﾀﾋね',
  'しねよ',
  'シネよ',
  'シネヨ',
  'しゃせい',
  '射精',
  '獣姦',
  '娼婦',
  'しょうべん',
  '小便',
  '女体盛り',
  'しんで',
  'しんどけ',
  'スカトロ',
  '素股',
  '性愛',
  '異性愛',
  '同性愛',
  '両性愛',
  '精液',
  '性交',
  '性行為',
  '精子',
  '性奴隷',
  'セックス',
  'せっくす',
  'セフレ',
  '鮮人',
  '朝鮮人',
  '朝鮮人民共和国',
  '全身舐め',
  'ぜつりん',
  '絶倫',
  'せんずり',
  '賤民',
  'だいべん',
  '大便',
  '大麻',
  'ダウンしょう',
  'ダウン症',
  'ダッチワイフ',
  'だっぷん',
  '脱法ハーブ',
  '玉責め',
  '玉舐め',
  'だまれ',
  '地下鉄サリン',
  'ちかてつサリン',
  '痴漢',
  '痴汁',
  '痴女',
  'ちしょう',
  'ちしょー',
  'チャンコロ',
  '直アド',
  '直メ',
  'チンカス',
  'ちんこ',
  'ち〇こ',
  'ち●こ',
  'ち◎こ',
  'ちんちん',
  'チンチン',
  'ちんぼ',
  'ちんぽ',
  'ちんぽこ',
  'ディープスロート',
  '低能',
  'ディルド',
  '手淫',
  'デカチン',
  'デカマラ',
  '手コキ',
  'デブ専',
  '手マン',
  '電動コケシ',
  '童貞',
  '床上手',
  '屠殺',
  '土人',
  '南極2号',
  '肉壺',
  '肉奴隷',
  '肉棒',
  '乳頭',
  '乳輪',
  '尿道球腺液',
  '売春',
  '買春',
  '売女',
  'パイズリ',
  '梅毒',
  'パイパン',
  '背面座位',
  'バカ',
  '白痴',
  'バター犬',
  '花びら回転',
  'ハメ撮り',
  'ヒトラー',
  'エッチ',
  '一人エッチ',
  'ファッキュー',
  'ファック',
  'フェラチオ',
  'プッシー',
  '部落',
  'へたくそ',
  'ペッティング',
  'ペニス',
  'ヘロイン',
  '包茎',
  'ぼっき',
  '勃起',
  'ホ別',
  'ポルチオ',
  'マジキチ',
  'マットプレイ',
  'まな板本番',
  '麻薬',
  'マンカス',
  'マン毛',
  'まんげ',
  'マンコ',
  'おまんこ',
  'ま〇こ',
  'ま●こ',
  'ま◎こ',
  '卍',
  'マン臭',
  'マン汁',
  'まんすじ',
  'ミコスリ半',
  'メアド',
  'めくら',
  'イメクラ',
  'めこすじ',
  'メスカリン',
  'メンヘラ',
  'やくたたず',
  '野獣先輩',
  'やめろ',
  'ヤリマン',
  'ラブジュース',
  '乱交',
  'リスカ',
  'リストカット',
  '凌辱',
  '陵辱',
  '輪姦',
  '淋病',
  'ルンペン',
  'レイプ',
  'レキソタン',
  'レンドルミン',
  'ロリコン',
  'ロンパリ',
  '和姦',
  // '\an[19]',
  // '\C[0]VID',
  // '\C[4]ネコ',
  // '\C[4]New',
  // '\figa',
  // '\fion',
  // '\fick',
  // '\fresse',
  // '\frocio',
  // '\fs[56]スイカ',
  // '\Gimp',
  // '\ni[9]',
  // '\ni[90]',
  'Abc-diät',
  'Abcdiät',
  'Abc-diet',
  'Abcdiet',
  'Abruti',
  'Abrutie',
  'ACAB',
  'Admin',
  'Affanculo',
  'Aids',
  'Anabootcamp',
  'Anal',
  'Analingus',
  'Analintruder',
  'Analplug',
  'Analsex',
  'Anilingus',
  'Anus',
  'Arse',
  'Arsebandit',
  'Arsehole',
  'Arsewipe',
  'Asphyxiophilia',
  'Ass',
  'A55',
  'Asshole',
  'Asswipe',
  'Arsch',
  'Arschloch',
  'Badword',
  'Bagascia',
  'Baise',
  'Baisé',
  'Baiser',
  'Baldracca',
  'Ballbag',
  'Balls',
  'Ballsac',
  'Ballsack',
  'Bastard',
  'Batard',
  'Battona',
  'Battyboy',
  'Battyman',
  'Bawbag',
  'Beastiality',
  'Beefcurtains',
  'Bellend',
  'Bitch',
  'Bltch',
  'B17ch',
  'Bite',
  'BJ',
  'Bloody',
  'Blowjob',
  'Boabie',
  'Bocchinara',
  'Bocchinaro',
  'Bollera',
  'Bollocks',
  'Bollox',
  'Boner',
  'Bong',
  'Boobjob',
  'Boobies',
  'Boobs',
  'Bougnoul',
  'Branleur',
  'Bukkake',
  'Bullshit',
  'Burne',
  'Buttplug',
  'Buttnugget',
  'Cabron',
  'Cabrón',
  'Cabrona',
  'Cabronazo',
  'Cack',
  'Camelcunt',
  'Cameltoe',
  'Cannabis',
  'Capper',
  'Capullo',
  'Carpetmuncher',
  'Cazzi',
  'Cazzo',
  'Chatroulette',
  'Chebs',
  'Chiavare',
  'Chichi',
  'Chickswithdicks',
  'Chier',
  'Ching',
  'Chingada',
  'Chingado',
  'Chingar',
  'Chingaso',
  'Chingazo',
  'Chink',
  'Choad',
  'Choch',
  'Chocho',
  'Chochotte',
  'Clit',
  'Clitoris',
  'Clunge',
  'Clusterfuck',
  'Cocaine',
  'Cock',
  'Cockend',
  'Cockgoblin',
  'Cockmuncher',
  'Cocknose',
  'Cocksucker',
  'Coglione',
  'Cojón',
  'Cojones',
  'Cok',
  'C0k',
  'Cokehead',
  'Computer',
  'Comepollas',
  'Con',
  'Connard',
  'Connasse',
  'Conne',
  'Coño',
  'Coon',
  'Coronavirus',
  'COVID',
  'Couille',
  'Couillo',
  'Couillon',
  'Couillonne',
  'Crackhead',
  'Crackwhore',
  'Crap',
  'Creampie',
  'Cretin',
  'Crevard',
  'Cul',
  'Culattone',
  'Culo',
  'Cum',
  'Cumshot',
  'Cumstain',
  'Cunilingus',
  'Cunnilingus',
  'Cunt',
  'Cuntflaps',
  'Cybersex',
  'Dago',
  'Damn',
  'Damnit',
  'Darkie',
  'DIAF',
  'Dick',
  'Dickcheese',
  'Dickhead',
  'Dicknose',
  'Dike',
  'Dildo',
  'Diobestia',
  'Diocane',
  'Dipshit',
  'Doggiestyle',
  'Doggystyle',
  'Doublepenetration',
  'Douchebag',
  'Douchefag',
  'DP',
  'Drecksack',
  'Drecksau',
  'Dunecoon',
  'Dyke',
  'Ejaculate',
  'Encule',
  'Enculé',
  'Enculer',
  'Enculér',
  'Enculle',
  'Enfoiré',
  'ETA',
  'Fadge',
  'Fag',
  'Fags',
  'Faggot',
  'Fandan',
  'Fap',
  'Fascist',
  'Fcuk',
  'Feck',
  'Felatio',
  'Felch',
  'Fellate',
  'Fellatio',
  'Feltch',
  'Feltching',
  'Fenian',
  'FFS',
  'Fica',
  'Fick',
  'Ficken',
  'Figa',
  'Fingerbang',
  'Fingerfuck',
  'Fion',
  'Fisting',
  'Fluffer',
  'FML',
  'FOAD',
  'Foll',
  'Follar',
  'Follen',
  'Fook',
  'Foreskin',
  'Fottere',
  'Fottiti',
  'Fotze',
  'Foutre',
  'Fresse',
  'Frocio',
  'Fucc',
  'Fuccd',
  'Fucced',
  'Fuccer',
  'Fucces',
  'Fuccing',
  'Fuccs',
  'Fuck',
  'Fu©k',
  'Fu@k',
  'F.u.c.k',
  'Fucker',
  'Fuckface',
  'Fucking',
  'Fucktard',
  'Fuckwit',
  'Fuct',
  'Fudgepacker',
  'Fugly',
  'Fuk',
  'Funbags',
  'Furcia',
  'Fvck',
  'Gangbang',
  'Gangrape',
  'Ganja',
  'Gaylord',
  'Gaytard',
  'Gilip',
  'Gilipollas',
  'Gimp',
  'Gizzum',
  'Gloryhole',
  'Glorywog',
  'Goatse',
  'Gobshite',
  'Goddamn',
  'Goddamnit',
  'Gonads',
  'Gooch',
  'Gook',
  'Goolies',
  'Gypo',
  'Gyppo',
  'Hakenkreuz',
  'Handjob',
  'Hard-on',
  'Hardon',
  'Hell',
  'Hentai',
  'Heroin',
  'Heroine',
  'Hitler',
  'Hiv',
  'Holocaust',
  'Holyshit',
  'Homo',
  'Hooker',
  'Hoormister',
  'Hostia',
  'Hurensohn',
  'Idiot',
  'Incest',
  'Inculare',
  'Intercourse',
  'ISIL',
  'ISIS',
  'Jackass',
  'Jackingoff',
  'Jackoff',
  'Jamrag',
  'Jap',
  'Japs',
  'Jap`seye',
  'Japseye',
  'Jaysis',
  'Jaysus',
  'Jerkingoff',
  'Jerkoff',
  'Jesussucks',
  'Jiggaboo',
  'Jism',
  'Jiz',
  'Jizm',
  'Jizz',
  'Jizzum',
  'Jod',
  'Joder',
  'Jodete',
  'Jódete',
  'Joputa',
  'Judensau',
  'Kacke',
  'Kaffir',
  'Kanacke',
  'Keech',
  'Kike',
  'Kill',
  'Killer',
  'KKK',
  'Klunge',
  'Knackers',
  'Knobend',
  'Knobhead',
  'Knobjockey',
  'Koon',
  'Kunt',
  'Kyke',
  'KZ',
  'La Puta',
  'Lardarse',
  'Lardass',
  'Lesbo',
  'Lezbo',
  'Lezzer',
  'Lezzie',
  'Loli',
  'Lolita',
  'Gothic Lolita',
  'Mamada',
  'Mamon',
  'Mamona',
  'Marica',
  'Marico',
  'Maricon',
  'Maricón',
  'Maricona',
  'Mariconazo',
  'Masterbate',
  'Masterbation',
  'Masturbat',
  'Masturbate',
  'Masturbating',
  'Masturbation',
  'Meatspin',
  'Merd',
  'Merda',
  'Merde',
  'SUMMER DREAM',
  'Mignotta',
  'Milf',
  'Minchia',
  'Minge',
  'Minger',
  'Mofo',
  'Molest',
  'Mong',
  'Mongoloid',
  'Motherfucker',
  'Muff',
  'N19',
  'Nazi',
  'Nazl',
  'Naz1',
  'Nazism',
  'Neger',
  'Negre',
  'Nègre',
  'Negresse',
  'Négresse',
  'Negro',
  'Nig',
  'Ni9',
  'Nl9',
  'N1g',
  'Nlg',
  'Niga',
  'Nigga',
  'Nigger',
  'Nignog',
  'Nig-nog',
  'Nique',
  'Niquer',
  'Nob',
  'Nobhead',
  'Nonce',
  'Numpty',
  'Nutsack',
  'Nutte',
  'Ojete',
  'OMFG',
  'Oralsex',
  'Orgasm',
  'Orgy',
  'Ostia',
  'Pädophiler',
  'Paedo',
  'Paedofile',
  'Paedophile',
  'Pajillero',
  'Paki',
  'Partouze',
  'PD',
  'Pecker',
  'Pédé',
  'Pederast',
  'Pedo',
  'Pedofile',
  'Pedophile',
  'Penis',
  'Pen1s',
  'P3nis',
  'P3n1s',
  'Petasse',
  'Pétasse',
  'Phuk',
  'Picha',
  'Pik',
  'Pikey',
  'Pimp',
  'Pine',
  'Piss',
  'Pisser',
  'Pissflaps',
  'Pisshead',
  'Polla',
  'Pollon',
  'Pollón',
  'Ponce',
  'Poof',
  'Poofter',
  'Pompinara',
  'Pompino',
  'Poon',
  'Poonanie',
  'Poontang',
  'Porcodio',
  'Dioporco',
  'Porn',
  'P0rn',
  'POS',
  'Potorro',
  'Pouffe',
  'Pouffiasse',
  'Pro-ana',
  'Proana',
  'Pro-mia',
  'Promia',
  'Pron',
  'Pr0n',
  'Pube',
  'Pubes',
  'Punani',
  'Pussy',
  'Puta',
  'Putain',
  'Pute',
  'Puto',
  'Puton',
  'Putón',
  'Puttana',
  'Queef',
  'Queer',
  'Raghead',
  'Rape',
  'Raped',
  'Rapes',
  'Grape',
  'Raping',
  'Rapist',
  'Skyscraper',
  'Rentboy',
  'Retard',
  'Retarded',
  'Ricchione',
  'Rimjob',
  'Rimming',
  'Ringpiece',
  'Rottinculo',
  'Rugmuncher',
  'SA',
  'Salaud',
  'Salop',
  'Salopard',
  'Salope',
  'Sambo',
  'Sandnigger',
  'Sau',
  'Sborra',
  'Scat',
  'Scheisse',
  'Scheiße',
  'Schlampe',
  'Schlick',
  'Schlomg',
  'Schwanz',
  'Schwuchtel',
  'Scrote',
  'Scrotum',
  'Segaiolo',
  'Semen',
  'Sex',
  'Sexy',
  'Sussex',
  'Shag',
  'Shagged',
  'Shagger',
  'Sheep',
  'Shirtlifter',
  'Shit',
  'Shitcunt',
  'Shite',
  'Shithead',
  'Shiz',
  'SIEGHEIL!',
  'Skank',
  'Slag',
  'Slapper',
  'Slave',
  'Slut',
  'S1ut',
  'S1utd',
  'Smeg',
  'Smegma',
  'Snatch',
  'SOAB',
  'Sod',
  'Sodding',
  'Sodomie',
  'Sodomise',
  'Sodomy',
  'Sonofabitch',
  'Son-of-a-bitch',
  'Spaccer',
  'Spack',
  'Spasti',
  'Spastic',
  'Spaz',
  'Sperm',
  'Spic',
  'Spick',
  'Spik',
  'Splooge',
  'Spunk',
  'SS',
  'STFU',
  'Stiffy',
  'Strap-on',
  'Strapon',
  'Stricher',
  'Subnormal',
  'Sucer',
  'Suicide',
  'Swastika',
  'Taig',
  'Tapette',
  'Tard',
  'Teabagged',
  'Teabagging',
  'Terrorist',
  'Testes',
  'Testicle',
  'Thinspiration',
  'Thinspo',
  'Tit',
  'Tits',
  'Titties',
  'Titty',
  'Titwank',
  'Tortillera',
  'Tosser',
  'Tosspot',
  'Towelhead',
  'Trannie',
  'Tranny',
  'Troia',
  'Troietta',
  'Troiona',
  'Troione',
  'Tubgirl',
  'Tugjob',
  'Turd',
  'Turdburglar',
  'Twat',
  'Vadge',
  'Vaffanculo',
  'Vag',
  'Vagin',
  'Vagina',
  'Vaj',
  'Vollidiot',
  'Vulva',
  'Wank',
  'Wanker',
  'Wankshaft',
  'Wankstain',
  'Wap',
  'Weed',
  'Whore',
  'Wichser',
  'Windowlicker',
  'Wog',
  'Wop',
  'WTF',
  'Yid',
  'Zob',
  'Zoccola',
  'Zoophilia',
  'Zorron',
  'Zorrón',
  'ガイジ',
  'キモイ',
  'きしょい',
  'くそ',
  'クソ',
  'チャンネル登録',
  'ウザイ',
  '馬鹿',
  '37564',
  'お世話になっております',
  '犯罪',
  '不幸',
  'ADHD',
  'ASD',
  '滅',
  'フレンドコード',
  'えぐい',
  'やばい',
  'www',
  '精通',
  '巨乳',
  '嫌い',
  'グロい',
  'デブ',
  '黙れ',
  '窒息',
  '墓',
  '強盗',
  '強盗犯',
  '不審者',
  'ストーカー',
  '勃',
  '犯罪者',
  '4545',
  '1919',
  'sex',
  'ダサい',
  'ださい',
  'ダサイ',
  'クズ',
  'ばか',
  '４５４５',
  '１９１９',
  '３７５６４',
  'アンチ',
  '変態',
  '４ね',
  '闇バイト',
  'シモネタ',
  '下ネタ',
  '指名手配',
  'さつじん',
  'unko',
  'ｕｎｋｏ',
  'fuck',
  'FUCK',
  'サイコパス',
  'さいこぱす',
  '不倫',
  'AIDS',
  'クラミジア',
  'ログインID',
  'パスワード',
  'くたばれ',
  'カジノ',
  'ギャンブル',
  'ブサイク',
  '不細工',
  'ぶさいく',
  '合法',
  'ハゲ',
  'ノーパン',
  '汚',
];
